// lib/fly-to-cart.ts - Alternative simplified version

export const flyToCart = (imageId: string) => {
  const cartIcon = document.getElementById("cart-icon");
  const productImg = document.getElementById(imageId);

  if (!cartIcon || !productImg) return;

  const cartRect = cartIcon.getBoundingClientRect();
  const imgRect = productImg.getBoundingClientRect();

  // Create flying element
  const flyingElement = document.createElement("div");
  flyingElement.style.position = "fixed";
  flyingElement.style.zIndex = "9999";
  flyingElement.style.pointerEvents = "none";
  flyingElement.style.transition =
    "all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
  flyingElement.style.borderRadius = "50%";
  flyingElement.style.overflow = "hidden";
  flyingElement.style.boxShadow = "0 4px 12px rgba(0,0,0,0.3)";

  // Clone and style image
  const clonedImg = productImg.cloneNode(true) as HTMLElement;
  clonedImg.style.width = "50px";
  clonedImg.style.height = "50px";
  clonedImg.style.objectFit = "cover";
  clonedImg.style.display = "block";

  flyingElement.appendChild(clonedImg);
  document.body.appendChild(flyingElement);

  // Calculate positions
  const startX = imgRect.left + imgRect.width / 2 - 25;
  const startY = imgRect.top + imgRect.height / 2 - 25;

  let endX = cartRect.left + cartRect.width / 2 - 25;
  const endY = cartRect.top + cartRect.height / 2 - 25;

  // Set initial position
  flyingElement.style.left = `${startX}px`;
  flyingElement.style.top = `${startY}px`;
  flyingElement.style.width = "50px";
  flyingElement.style.height = "50px";

  // Trigger reflow
  flyingElement.offsetHeight;

  // Animate to cart
  flyingElement.style.left = `${endX}px`;
  flyingElement.style.top = `${endY}px`;
  flyingElement.style.width = "10px";
  flyingElement.style.height = "10px";
  flyingElement.style.opacity = "0.5";

  // Clean up and add cart bounce
  setTimeout(() => {
    // Cart bounce effect
    cartIcon.style.transform = "scale(1.3)";
    cartIcon.style.transition = "transform 0.2s";

    setTimeout(() => {
      cartIcon.style.transform = "scale(1)";
    }, 200);

    // Remove flying element
    if (document.body.contains(flyingElement)) {
      document.body.removeChild(flyingElement);
    }
  }, 800);
};
